import AsyncIndicator from "AsyncIndicator";
import { waitForEntityManagerOperationsAsync } from "EntityManagerExtensions";
import { CancellationError } from "Errors";
import type { FormFlowUI } from "FormFlowUITypes";
import widgetUtils from "WidgetUtils";

export async function runExclusiveAsync<T>(formFlowUI: FormFlowUI, callback: () => T): Promise<T> {
  if (formFlowUI.isBusy() || !formFlowUI.formAwaiter || !formFlowUI.formAwaiter.isPending) {
    throw new CancellationError();
  }

  const asyncIndicator = new AsyncIndicator();
  asyncIndicator.show();
  formFlowUI.isBusy(true);
  try {
    await widgetUtils.waitIdleAllWidgetsAsync(formFlowUI.$shell!);

    const entity = formFlowUI.entity?.();
    if (entity) {
      await waitForEntityManagerOperationsAsync(entity.entityAspect.entityManager);
    }

    return await callback();
  } finally {
    await asyncIndicator.hideAsync();
    formFlowUI.isBusy(false);
  }
}
